import { render, staticRenderFns } from "./vipTeacherDetail.vue?vue&type=template&id=fbbb45f6&scoped=true&"
import script from "./vipTeacherDetail.vue?vue&type=script&lang=js&"
export * from "./vipTeacherDetail.vue?vue&type=script&lang=js&"
import style0 from "./vipTeacherDetail.vue?vue&type=style&index=0&id=fbbb45f6&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fbbb45f6",
  null
  
)

export default component.exports